/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_PeopleInputs */

const en_directory_search_people = /** @type {(inputs: Directory_Search_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

const pl_directory_search_people = /** @type {(inputs: Directory_Search_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osoby`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Directory_Search_PeopleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_people = /** @type {((inputs?: Directory_Search_PeopleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_PeopleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_people(inputs)
	return en_directory_search_people(inputs)
});